<template>
  <div id="edit-exploration">

    <!-- Create Point Modal -->
    <CreatePoint :index="index" :exploration="exploration" v-on:closeCreatePoint="showCreatePoint = false" v-if="showCreatePoint == true"></CreatePoint>

    <div class="container" v-if="showCreatePoint == false">
      <router-link :to="{ name: 'Dashboard'}" class="btn btn-outline-primary btn-sm mb-2 mt-2"><i class="fal fa-arrow-left"></i> Dashboard</router-link>
      <h1>{{ exploration.title }}</h1>
      <button @click="createPoint()" class="btn btn-outline-primary mt-2"><i class="fal fa-plus-circle"></i> Create Point</button>
      <router-link :to="{ name: 'Exploration', params: {id: exploration.id, mode: 'list'} }" class="btn btn-outline-success mt-2" target="_blank"><i class="fal fa-map-marked"></i> Launch Exploration</router-link>
      <router-link :to="{ name: 'Presentation', params: {id: exploration.id} }" class="btn btn-outline-success mt-2"><i class="fal fa-presentation"></i> Presentation Mode</router-link>
      <div class="mt-4">
        <div v-if="exploration">
          <draggable v-model="exploration.points" :options="{}" @start="drag=true" @end="saveOrder()">
            <div v-for="(point, index) in exploration.points" class="card mt-2">
              <div class="card-body grabable p-2 pl-4">
                <p class="mb-0 lead">{{ point.title }} <button @click="deletePoint(index)" class="btn btn-sm btn-outline-danger float-right mr-1"><i class="fal fa-trash"></i></button><router-link :to="{ name: 'Exploration', params: {id: exploration.id, mode: 'point', slug: point.slug} }" target="_blank" class="btn btn-sm btn-outline-success mr-1 float-right"><i class="fal fa-arrow-alt-right"></i></router-link><button @click="editPoint(index)" class="btn btn-sm btn-outline-primary mr-1 float-right"><i class="fal fa-cog"></i></button></p>
              </div><!-- /.card-body -->
            </div><!-- /.card -->
          </draggable>
        </div><!-- /if -->
        <div v-else><p>No Points yet!</p></div>
      </div>

    </div>
  </div>
</template>

<script>
  import CreatePoint from './CreatePoint.vue'
  const fb = require('../firebaseConfig.js')
  import draggable from 'vuedraggable'

  export default {
    data() {
      return {
        exploration: {},
        showCreatePoint: false,
        index: null
      }
    },
    created() {
      fb.explorationsCollection.doc(this.$route.params.id).onSnapshot(doc => {
        this.exploration = doc.data()
        this.exploration.id = doc.id
      })
    },
    components: {
      CreatePoint,
      draggable
    },
    methods: {
      saveOrder() {
        fb.explorationsCollection.doc(this.exploration.id).update({
          points: this.exploration.points
        })
      },
      editPoint(index) {
        this.index = index
        this.showCreatePoint = true
      },
      deletePoint(index) {
        let check = confirm("DANGER!!! Are you sure you want to delete this Point? THIS CANNOT BE UNDONE!!")
        if (check == true) {
          this.exploration.points.splice(index, 1)
          fb.explorationsCollection.doc(this.exploration.id).update({
            points: this.exploration.points
          }).then(ref => {
          })
        } else {
          return false
        }
      },
      createPoint() {
        this.index = null
        this.showCreatePoint = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EditExploration.vue